import { types } from "../types/types";
const intitalState = {
    allPayments: [],
    pagination: { page: 1, limit: 50, total: 0, totalPages: 0 },
};

const paymentReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.PAYMENT:
            return {
                ...state,
                allPayments: action.payload.data || [],
                pagination: action.payload.pagination || state.pagination,
            };
        default:
            return { ...state };
    }
};

export default paymentReducer;
